import React from 'react';
import { LinkWithScroll } from '../util/scroll.js';
export const Link = (props) => (props.isExternalLink ?
    React.createElement("a", { className: props.className, href: props.url }, props.content)
    :
        React.createElement(LinkWithScroll, { className: props.className, to: props.url }, props.content));
